// import React, { useState, useEffect } from "react";
// import styles from "../../assets/scss/Billing/AddBilling.module.scss";
// import Pagination from "../../Components/Common/Pagination";
// import PopupWrapper from "../../Components/Common/PopupWrapper";
// import TransportHandlersForm from "./TransportHandlersForm";
// import { useLocation, useNavigate } from "react-router-dom";
// import { FaEye } from "react-icons/fa6";

// const TransportHandlersBillingView = () => {
//     const [currentPage, setCurrentPage] = useState(1);
//     const [limit, setLimit] = useState(10);
//     const [showPopup, setShowPopup] = useState(false); // ✅ Popup state

//     const navigate = useNavigate();
//     const location = useLocation();

//     // ✅ Static Customer
//     const customer = {
//         firstName: "Suriya",
//         phone: "9080706050",
//     };

//     // ✅ Static Transactions
//     const transactions = [
//         {
//             _id: "1",
//             journalId: "JNL-001",
//             receiptNo: "RCPT-101",
//             createdAt: new Date(),
//             paymentStatus: "Paid",
//             paymentMethod: "Cash",
//             handleBy: { firstName: "Admin", lastName: "User" },
//             credit: 5000,
//             debit: 0,
//         },
//         {
//             _id: "2",
//             journalId: "JNL-002",
//             receiptNo: "RCPT-102",
//             createdAt: new Date(),
//             paymentStatus: "Pending",
//             paymentMethod: "UPI",
//             handleBy: { firstName: "Karthik", lastName: "" },
//             credit: 0,
//             debit: 3000,
//         },
//     ];

//     useEffect(() => {
//         setCurrentPage(1);
//     }, [limit]);

//     const totalPages = Math.ceil(transactions.length / limit);

//     return (
//         <div className={styles.billingContainer}>
//             {/* ================= HEADER ================= */}
//             <div className={styles.header}>
//                 <h2 className={styles.tittle}>Transport & Handler Ledger</h2>
//                 <span
//                     className={styles.closeIcon}
//                     onClick={() =>
//                         navigate("/dashboard/billing", {
//                             state: { activeTab: "transport" }
//                         })
//                     }
//                 >
//                     ✕
//                 </span>
//             </div>

//             {/* ================= CUSTOMER INFO ================= */}
//             <div className={styles.billingContainers}>
//                 <div className={styles.formSection}>
//                     <div className={styles.ownerBoxxx}>
//                         <p>
//                             <strong>Transport Owner :</strong> {customer.firstName}
//                         </p>
//                         <p>
//                             <strong>Phone No :</strong> {customer.phone}
//                         </p>
//                     </div>
//                 </div>
//             </div>

//             {/* ================= TRANSACTIONS ================= */}
//             <div className={styles.billingContainers}>
//                 <div className={styles.itemsHeader}>
//                     <h4>Transactions</h4>

//                     {/* ✅ OPEN POPUP */}
//                     <button
//                         className={styles.addItemBtn}
//                         onClick={() => setShowPopup(true)}
//                     >
//                         Add Amount
//                     </button>
//                 </div>

//                 <div className={styles.itemsSection}>
//                     <div className={styles.tableWrapper}>
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Journal ID</th>
//                                     <th>Receipt ID</th>
//                                     <th>Transaction Date</th>
//                                     <th>Payment Status</th>
//                                     <th>Payment Method</th>
//                                     <th>Handle By</th>
//                                     <th>Credit</th>
//                                     <th>Debit</th>
//                                 </tr>
//                             </thead>

//                             <tbody>
//                                 {transactions.map((txn) => (
//                                     <tr key={txn._id}>
//                                         <td>{txn.journalId}</td>
//                                         <td>{txn.receiptNo}</td>
//                                         <td>
//                                             {new Date(txn.createdAt).toLocaleString("en-US")}
//                                         </td>

//                                         <td
//                                             className={
//                                                 txn.paymentStatus.toLowerCase() === "paid"
//                                                     ? styles.statusPaid
//                                                     : styles.statusPending
//                                             }
//                                         >
//                                             {txn.paymentStatus}
//                                         </td>

//                                         <td>{txn.paymentMethod}</td>

//                                         <td>
//                                             {txn.handleBy
//                                                 ? `${txn.handleBy.firstName} ${txn.handleBy.lastName}`
//                                                 : "-"}
//                                         </td>

//                                         <td>₹{txn.credit}</td>
//                                         <td>₹{txn.debit}</td>
//                                     </tr>
//                                 ))}

//                                 {transactions.length === 0 && (
//                                     <tr>
//                                         <td colSpan="8" style={{ textAlign: "center" }}>
//                                             No transactions found
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>

//                         {/* ✅ TOTAL */}
//                         <div className={styles.dflexamount}>
//                             <div>
//                                 <h3>Total Credit Amount :</h3>
//                             </div>
//                             <div>
//                                 <h3>
//                                     ₹
//                                     {transactions.reduce(
//                                         (acc, curr) => acc + curr.credit,
//                                         0
//                                     )}
//                                 </h3>
//                             </div>
//                         </div>
//                     </div>

//                     {/* ================= PAGINATION ================= */}
//                     <div className={styles.paginationWrapper}>
//                         <Pagination
//                             currentPage={currentPage}
//                             totalPages={totalPages}
//                             onPageChange={setCurrentPage}
//                         />

//                         <select
//                             className={styles.inputsbtn}
//                             value={limit}
//                             onChange={(e) => setLimit(Number(e.target.value))}
//                         >
//                             <option value={10}>10 rows</option>
//                             <option value={25}>25 rows</option>
//                             <option value={50}>50 rows</option>
//                         </select>
//                     </div>
//                 </div>

//                 {/* ================= FOOTER ================= */}
//                 <div className={styles.footerButtons}>
//                     <button
//                         className={styles.cancelBtn}
//                         onClick={() => navigate(-1)}
//                     >
//                         Close
//                     </button>
//                 </div>
//             </div>

//             {/* ================= POPUP ================= */}
//             {showPopup && (
//                 <PopupWrapper onClose={() => setShowPopup(false)}>
//                     <TransportHandlersForm
//                         onClose={() => setShowPopup(false)}
//                     />
//                 </PopupWrapper>
//             )}
//         </div>
//     );
// };

// export default TransportHandlersBillingView;


import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Billing/AddBilling.module.scss";
import Pagination from "../../Components/Common/Pagination";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import TransportHandlersForm from "./TransportHandlersForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetParticularTempEmployeeLedgerQuery } from "../../slices/admin/admin";


const TransportHandlersBillingView = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showPopup, setShowPopup] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const empId = queryParams.get("id");

    // ✅ API CALL
    const { data, isLoading, refetch } =
        useGetParticularTempEmployeeLedgerQuery(
            {
                empId,
                offset: currentPage,
                limit,
            },
            { skip: !empId }
        );

    const transactions = data?.data || [];
    const employee = transactions[0]?.empId;
    const totalPages = Math.ceil((data?.total || 0) / limit);

    useEffect(() => {
        setCurrentPage(1);
    }, [limit]);

    return (
        <div className={styles.billingContainer}>
            {/* ================= HEADER ================= */}
            <div className={styles.header}>
                <h2 className={styles.tittle}>Transport & Handler Ledger</h2>
                <span
                    className={styles.closeIcon}
                    onClick={() =>
                        navigate("/dashboard/billing", {
                            state: { activeTab: "transport" }
                        })
                    }
                >
                    ✕
                </span>
            </div>

            {/* ================= EMPLOYEE INFO ================= */}
            {employee && (
                <div className={styles.billingContainers}>
                    <div className={styles.formSection}>
                        <div className={styles.ownerBoxxx}>
                            <p>
                                <strong>Name :</strong> {employee.name}
                            </p>
                            <p>
                                <strong>Phone :</strong> {employee.phone}
                            </p>
                            <p>
                                <strong>Designation :</strong>{" "}
                                {employee.empDesignation}
                            </p>
                            <div className={styles.amountRow}>
                                <span>Total Pending :</span>
                                <span className={styles.pendingBadge}>
                                    ₹ {data?.totalPendingAmount || 0}
                                </span>
                            </div>
                            {/* <div className={styles.amountRow}>
                                <span>Total Paid :</span>
                                <span className={styles.paidBadge}>
                                    ₹ {data?.totalPaidAmount || 0}
                                </span>
                            </div> */}
                            {/* <p>
                                <strong>Total Amount :</strong>    ₹{" "}
                                {transactions.reduce(
                                    (acc, curr) => acc + (curr.amount || 0),
                                    0
                                )}
                            </p> */}

                        </div>
                    </div>
                </div>
            )}

            {/* ================= TRANSACTIONS ================= */}
            <div className={styles.billingContainers}>
                <div className={styles.itemsHeader}>
                    <h4>Transactions</h4>

                    {/* ✅ OPEN POPUP */}
                    <button
                        className={styles.addItemBtn}
                        onClick={() => setShowPopup(true)}
                    >
                        Pay Transport Amount
                    </button>
                </div>

                <div className={styles.itemsSection}>
                    <div className={styles.tableWrapper}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Receipt No</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Payment Method</th>
                                    <th>Amount</th>
                                    <th>Payable</th>
                                    <th>Note</th>
                                </tr>
                            </thead>

                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="7">Loading...</td>
                                    </tr>
                                ) : transactions.length > 0 ? (
                                    transactions.map((txn) => (
                                        <tr key={txn._id}>
                                            <td>{txn.billId?.receiptNo || "Amount Paid"}</td>

                                            <td>
                                                {new Date(
                                                    txn.createdAt
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                <span
                                                    className={
                                                        txn.status === "paid"
                                                            ? styles.statusPaidBadge
                                                            : styles.statusPendingBadge
                                                    }
                                                >
                                                    {txn.status === "paid" ? "Paid" : "Pending"}
                                                </span>
                                            </td>
                                            <td>{txn.paymentMethod || "-"}</td>

                                            <td>₹ {txn.amount || 0}</td>
                                            <td>₹ {txn.payableAmount || 0}</td>
                                            <td>{txn.note || "-"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center" }}>
                                            No transactions found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* ✅ TOTAL CREDIT CALCULATION */}
                        {/* <div className={styles.dflexamount}>
                          <div>
                                <h3>Total Amount :</h3>
                            </div> 
                            <div>
                                <h3>
                                    ₹{" "}
                                    {transactions.reduce(
                                        (acc, curr) => acc + (curr.amount || 0),
                                        0
                                    )}
                                </h3>
                            </div>
                        </div> */}
                    </div>

                    {/* ================= PAGINATION ================= */}
                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />

                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>

                {/* ================= FOOTER ================= */}
                <div className={styles.footerButtons}>
                    <button
                        className={styles.cancelBtn}
                        onClick={() =>
                            navigate("/dashboard/billing", {
                                state: { activeTab: "transport" }
                            })
                        }
                    >
                        Close
                    </button>
                </div>
            </div>

            {/* ================= POPUP ================= */}
            {showPopup && (
                <PopupWrapper
                    onClose={() => {
                        setShowPopup(false);
                        refetch(); // 🔥 refresh ledger after popup close
                    }}
                >
                    <TransportHandlersForm
                        empId={empId}
                        onClose={() => {
                            setShowPopup(false);
                            refetch(); // 🔥 refresh after adding amount
                        }}
                    />
                </PopupWrapper>
            )}
        </div>
    );
};

export default TransportHandlersBillingView;